export const hotelCategories = {
  resort: "リゾート",
  allInclusive: "オールインクルーシブ",
  villa: "ヴィラタイプ",
  ryokan: "旅館",
};
